import React from 'react';
import { Remote } from '@okapi/remote';
import { Container, sectionDivider } from 'features/product/product-carousel/styles';
import type { ProductCarouselProps } from './types';
import { getWidgetName } from './utils/get-widget-name';
import { css } from 'linaria';

export const ProductCarousel = ({
  id = 'placements-carousel',
  title = '',
  titleAs = 'h2',
  productsIds = [],
  rrTracking,
  _productsLimit,
  variant = '',
  isFromPdp = false,
  showSeeMore = false,
  withDivider = false,
  elementBlock = 'not set',
  _additionalProducts = [],
  marginVertical = 0,
  lengthMin = 1,
  lengthMax = _productsLimit,
  noScroll = false,
}: ProductCarouselProps) => {
  const productsLimitedByMax = [...productsIds].slice(0, lengthMax ?? productsIds.length);
  const productsLimitedByMin = productsLimitedByMax.length >= lengthMin ? productsLimitedByMax : [];
  const productsToDisplay = Array.from(new Set([...productsLimitedByMin, ..._additionalProducts]));

  if (!productsToDisplay.length) return null;

  return (
    <Container
      data-qa="placements/product-carousel"
      className={withDivider ? sectionDivider : ''}
      marginVertical={marginVertical}>
      <Remote
        widget={getWidgetName(variant)}
        id={id}
        data={{
          title,
          titleAs,
          productsIds: productsToDisplay,
          showSeeMore,
          isFromPdp,
          rrTracking,
          elementBlock,
          innerContainerClassName: noScroll ? noScrollStyle : '',
          flatListClassName: flatListStyle,
        }}
        fallback={null}
      />
    </Container>
  );
};

const noScrollStyle = css`
  overflow-x: hidden !important;
`;

const flatListStyle = css`
  height: auto !important;
  grid-auto-rows: min-content;
`;
